import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import LoanerDashboard from './components/LoanerDashboard';
import LoaneeDashboard from './components/LoaneeDashboard';
import './styles/App.css';

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
}

function DashboardRouter() {
  const { userRole, currentUser, signOut } = useAuth();
  const [showAdminPanel, setShowAdminPanel] = React.useState(false);

  async function handleSignOut() {
    try {
      await signOut();
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  }

  return (
    <div className="app">
      <nav className="navbar">
        <div className="navbar-content">
          <h1 className="navbar-title">Family Loan App</h1>
          <div className="navbar-user">
            <img 
              src={currentUser?.photoURL || 'https://via.placeholder.com/40'} 
              alt="User" 
              className="user-avatar"
            />
            <span className="user-name">{currentUser?.displayName}</span>
            <span className="user-role">{userRole}</span>
            {userRole === 'admin' && (
              <button 
                onClick={() => setShowAdminPanel(!showAdminPanel)} 
                className="btn btn-icon"
                title="Admin Settings"
                style={{
                  padding: '0.5rem',
                  fontSize: '1.2rem',
                  marginRight: '0.5rem'
                }}
              >
                ⚙️
              </button>
            )}
            <button onClick={handleSignOut} className="btn btn-secondary">
              Sign Out
            </button>
          </div>
        </div>
      </nav>

      <main className="main-content">
        {userRole === 'admin' && (
          <>
            {showAdminPanel ? (
              <AdminDashboard />
            ) : (
              <LoanerDashboard />
            )}
          </>
        )}
        {userRole === 'loaner' && <LoanerDashboard />}
        {userRole === 'loanee' && <LoaneeDashboard />}
        {userRole === 'new_user' && (
          <div className="empty-state" style={{marginTop: '4rem'}}>
            <h2>Account Pending Approval</h2>
            <p>Your account has been created but requires administrator approval before you can access the system.</p>
            <p>Please contact an administrator to assign you a role.</p>
          </div>
        )}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardRouter />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
